'use client';

const loadingStartMsg = "Loading options";
const loadingEndMsg = "Options loaded";
const emptyMsg = "No results found";
export {
  emptyMsg,
  loadingEndMsg,
  loadingStartMsg
};
